import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { combineLatest, forkJoin } from 'rxjs';
import { ImageGalleryComponent } from 'src/app/components/shared/image-gallery/image-gallery.component';
import { ClientService } from 'src/app/services/client.service';
import { ContractService } from 'src/app/services/contract.service';
import { EnvironmentService } from 'src/app/services/environment.service';
import { LegalService } from 'src/app/services/legal.service';
import { OverlayService } from 'src/app/services/overlay.service';
import { PropertyService } from 'src/app/services/property.service';
import { ServiceService } from 'src/app/services/service.service';

@Component({
  selector: 'app-params',
  templateUrl: './params.component.html',
  styleUrls: ['./params.component.scss']
})
export class ParamsComponent implements OnInit {
  client = null;
  allProperties = null;
  clientProperties = null;

  clientConfiguration = [];
  contracts = [];
  services = [];
  legalInformation = [];

  parameterData = null;
  officeHours = null;
  address = null;

  basicDataHasChanged = false;
  serviceHasChanged = [];
  addressHasChanged = false;
  legalHasChanged = [];

  serviceFilter = null;

  legalSections = [
    { title: 'Teilnahmebedingungen', key: 'participation' },
    { title: 'Datenschutzhinweise', key: 'privacy' },
    { title: 'Impressum', key: 'about' },
    { title: 'Kontakt', key: 'contact' }
  ];

  imageProperties = [
    { showValue: 'Logo', key: 'logo', value: null, hint: 'Format: 180 x 90, Typ: .png', hasChanged: false },
    { showValue: 'Favicon', key: 'favicon.path', value: null, hint: 'Format: 16 x 16, Typ: .ico', hasChanged: false },
    { showValue: 'Appleicon', key: 'appletouchicon.path', value: null, hint: 'Format: 76 x 76, Typ: .png', hasChanged: false }
  ];

  finishedLoading:boolean = false;


  constructor(
    private clientService: ClientService,
    private propertyService: PropertyService,
    private overlayService: OverlayService) { }

  ngOnInit() {
    this.propertyService.getProperty();

    combineLatest([
      this.propertyService.getProperties(),
      this.propertyService.getPropertyConfiguration(),
      this.clientService.getClientAddress(),
    ]).subscribe(res => {
      console.log(res)
      this.allProperties = res[0];
      this.clientProperties = res[1];
      this.setClientConfiguration();
    });
  }




  setClientConfiguration() {
    const toSkip = this.imageProperties.map(prop => prop.key);
    toSkip.push('officehours.notification');

    this.clientConfiguration = Object.keys(this.allProperties).map(key => {
      for (let p of this.clientProperties) {
        if (p.publicId == key && toSkip.indexOf(key) < 0) {
          return { ... this.allProperties[key], value: p.value, publicId: key }
        }
      }
      return false
    }).filter(val => val);

    this.finishedLoading = true;
  }

  saveProperty(property) {
    console.log(property)
    this.propertyService.updateProperty(property.publicId, property.value).subscribe({
      next: () => {
        this.overlayService.openSnackBar(`Parameter ${property.displayName} erfolgreich aktualisiert.`);
      },
      error: (err) => {
        this.overlayService.openSnackBar(`Fehler beim Aktualisieren von ${property.displayName}: ${err.error.message}`, 'error');
      }
    });
  }

}